/**
 * Outer shell for every use-case module. Renders the eyebrow, title, lede,
 * step indicator, the module body (provided as `children`), and the
 * right-rail case chat. Pages plug in by composing this layout with their
 * own step content -- TestCaseList, FileDropZone, Run button, ResultsPanel.
 */
import React, { useEffect } from 'react';
import CaseChatDrawer from './CaseChatDrawer';

export default function WorkflowLayout({
  module,
  currentStep = 'choose',
  skippedSteps = [],
  caseContext = '',
  chatTitle,
  children,
  showChat = false,
}) {
  useEffect(() => {
    if (module?.name) document.title = `${module.name} · CerebralMachines`;
  }, [module]);

  return (
    <div className={showChat ? 'wf-page' : 'wf-page wf-page--no-rail'}>
      <div className="wf-main">
        <header className="wf-head">
          <span className="wf-head__eyebrow">{module?.eyebrow || module?.name}</span>
          <h1 className="wf-head__title">{module?.title || module?.name}</h1>
          {module?.lede && <p className="wf-head__lede">{module.lede}</p>}
        </header>

        {children}
      </div>

      {showChat && (
        <CaseChatDrawer
          caseContext={caseContext}
          title={chatTitle || `Ask about this ${module?.name || 'case'}`}
        />
      )}
    </div>
  );
}
